<div class="SLV2-questn-card " (click)=" navigateToPracticetest()">
    <span class="SLV2-questn-lst-cunt"></span>
    <div class="SLV2-questn-thumb">
        <ng-container>
            <img src="selflearnv2-ui/assets/img/self-learn-v2/question-card-thumb.svg" class="SLV2-question-thumb-pic" />
        </ng-container>
        <!-- <img *ngIf="questionData?.thumbnailURL" src='{{displayImage(questionData.thumbnailURL)}}' />
        <span class="SLV2-questn-time-tag">{{displayTime(questionData.duration)}}</span>
        <span class="SLV2-questn-subjct-name">{{questionData.subjects[0].subject}}</span> -->
    </div>
    <div class="SLV2-questn-content-area">
        <div class="SLV2-questn-info-row">
            <div class="SLV2-questn-info">
                <img src="selflearnv2-ui/assets/img/eye-icon-2.svg" /><span>{{noOfViews}} views</span>
            </div>
        </div>
        <h4 class="SLV2-questn-title">Q.<span [mathMl]="questionData.qbdata.question.question_text"></span></h4>
    </div>
</div>